import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import { useState } from "react";
import moment from "moment";

const headers = [
  {
    key: "exchange_rate",
    name: "THB to MMK",
  },
  {
    key: "reverse_exchange_rate",
    name: "MMK to THB",
  },
  {
    key: "exchange_rate_date",
    name: "Exchange Date",
  },
  {
    key: "status",
    name: "Status",
  },
];

const CurrencyExchangeList = () => {
  const [searchValue, setSearchValue] = useState(""); 
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/currencyExchange",
  });

  // const handleSearch = (value) => {
  //   const trimmed = value.trim();
  //   if(trimmed.length > 0){
  //     setSearchValue(trimmed);
  //     setQuery({
  //       search: trimmed,
  //     });
  //   }else{
  //     setQuery({});
  //   }
  // };

  const handleSearch = (value) => {
  const trimmed = value.trim();

  // Optional: Try converting date to YYYY-MM-DD
  const m = moment(trimmed, ['DD/MM/YYYY', 'D/M/YYYY'], true);
  const formatted = m.isValid() ? m.format('YYYY-MM-DD') : trimmed;

  if (formatted.length > 0) {
    setSearchValue(trimmed);
    setQuery({
      search: formatted,
    });
  } else {
    setQuery({});
  }
};


  const nothingFoundAfterSearch =
  searchValue && Array.isArray(data?.results) && data.results.length === 0;


  return (
    <TableLayout
      title="Currency Exchange List"
      data={data}
      headers={headers}
      idKey="exchange_rate_id"
      endPoint="/currencyExchange"
      removeDetails={true}
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      hasActions
      module="Currency Exchange"
      createPath={`/currency-exchange/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}                      
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default CurrencyExchangeList;
